import React, { useEffect, useState } from 'react';
import './networkManagment.scss';
import { Tabs, Table, Avatar, Button, Tag, Space, Row, Col, Input, Modal, List } from 'antd';
import { PlusOutlined, EyeOutlined, SearchOutlined, CloseOutlined, ExclamationCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { appDispatch, RootState } from '../../../app/store';
import {  fetchONRoles, fetchONUserDetails, fetchRequestLists, resetFetchONSpecialities } from '../../../features/superAdmin/requestLIsts/requestListsSlice';
import { toast } from 'react-toastify';
import { Skeleton, Card } from 'antd';
import { UserDetailsModal } from '../requestLists/components/userDetailsModal/UserDetailsModal';
import { DEFAULT_PROFILE_IMAGE, SUPER_ADMIN_API_URL } from '../../../constants';
import SimpleButton from '../../../components/buttons/simpleButton/SimpleButton';
import { LiaSearchSolid } from 'react-icons/lia';
// import NonMemberListAction from './nonMemberListAction';
import { activateMembers, deactivateMembers, deleteMembers, fetchDeactivatedNetworksList, fetchDeletedMembersList, fetchDynamicNetworksList, fetchMembersList, fetchNonMembersList, fetchViewDynamicNetworksList, fetchViewNetworksList, filterMembers } from '../../../features/members/membersSlice';
import { fetchNotesList } from '../../../features/users/usersSlice';
import { NetworkDetailsModal } from './networkdetailsModal/networkdetailsModal';


interface UserData {
  key: string;
  name: string;
  email: string;
  status: string;
  avatar: string;
}

export const NetworkMangement = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch<appDispatch>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [activeTab, setActiveTab] = useState<string>('networks');
  const [searchquery, setSearchquery] = useState<string>("");

  const [licenseNumbers, setLicenseNumbers] = useState<string[]>([]);
  const [updatedData, setUpdatedData] = useState<any[]>([]);
  const [isUserDetailModalVisible, setIsUserDetailModalVisible] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  const networkData= useSelector((state: RootState) => state.members.fetchViewDeactivatedNetworksList.fetchViewDeactivatedNetworksListData);
const nonMembersList = useSelector(
  (state: RootState) => state.members.fetchNetworksList.fetchNetworksListData
);

const deactivatedNetworksList = useSelector(
  (state: RootState) => state.members.fetchDeactivatedNetworksList.fetchDeactivatedNetworksListData
);

console.log(deactivatedNetworksList,"deactivatedNetworksList")
  
const { confirm } = Modal;

  const handleShowLicenses = (numbers: string[]) => {
    setLicenseNumbers(numbers);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setLicenseNumbers([]);
  };
  
  const {
    fetchNonMembersListData,
    isLoading,
    totalCount
  } = useSelector((state: RootState) => state.members.fetchNonMembersList);

  useEffect(()=>{
    setUpdatedData(updatedData)
    console.log(updatedData,"updateddata")
  },[updatedData])

  useEffect(() => {
    if (activeTab === "networks") {
      setUpdatedData(nonMembersList || []);
  
    }
  }, [ nonMembersList]);

  // useEffect(() => {
  //   const currentTab = TABS.find(tab => tab.key === activeTab);
  //   const thunkArgs = { searchquery: searchquery || "", pageNumber: 1 };

  //   if (currentTab?.key === 'networks') {
  //     dispatch(fetchDynamicNetworksList(thunkArgs));
  //   } 
  // }, [searchquery]);

  useEffect(() => {
    const thunkArgs = {
      searchquery: searchquery || "",
      pageNumber: 1,

    }

      dispatch(fetchDeactivatedNetworksList(thunkArgs));
    dispatch(fetchDynamicNetworksList(thunkArgs));

  }, []);



  const handleDeactivateUser = () => {
  confirm({
    title: "Confirm Deactivation",
    icon: <ExclamationCircleOutlined />,
    content: `Are you sure you want to deactivate network '${selectedRowIds?.toString()}'?`,
    centered: true,
    onOk() {
      const payload = {
      network_name:selectedRowIds?.toString()

      };
      dispatch(deactivateMembers(payload))
        .then((data) => {
          if (data.payload.isSuccess) {
            toast.success(data.payload.message);
            resetTableSelection();
            setTimeout (()=>{
            dispatch(fetchDynamicNetworksList({ searchquery, pageNumber })); // refresh
            },1000)
       

          } else {
            toast.error(data.payload);
          }
        })
        .catch((error) => {
          console.error("Delete failed:", error);
        });
    },
    onCancel() {},
  });
};


  const handleActivateUser = () => {
  confirm({
    title: "Confirm Activation",
    icon: <ExclamationCircleOutlined />,
    content: `Are you sure you want to activate network '${selectedRowIds?.toString()}'?`,
    centered: true,
    onOk() {
      const payload = {
      network_name:selectedRowIds?.toString()

      };
      dispatch(activateMembers(payload))
        .then((data) => {
          if (data.payload.isSuccess) {
            toast.success(data.payload.message);
            resetTableSelection();
            setTimeout (()=>{
            dispatch(fetchDeactivatedNetworksList({ searchquery, pageNumber })); // refresh
            },1000)
       

          } else {
            toast.error(data.payload);
          }
        })
        .catch((error) => {
          console.error("Delete failed:", error);
        });
    },
    onCancel() {},
  });
};
  const handleSearch = () => {
    const params = {
      searchquery: searchquery ? searchquery:""
    }
    if (activeTab === "networks") {
      dispatch(fetchDynamicNetworksList(params));

    }

      if (activeTab === "deactivated") {
      dispatch(fetchDeactivatedNetworksList(params));

    }
   
  }


const rowSelection = {
  selectedRowKeys: selectedRowIds,
  onChange: (newSelectedRowKeys: React.Key[], newSelectedRows: any[]) => {
    setSelectedRowIds(newSelectedRowKeys);
    setSelectedRows(newSelectedRows);
  },
onSelect: (record:any, selected:any) => {
  if (selected) {
    const allKeys = updatedData.map((item) => item.id);
    setSelectedRowIds(allKeys);
  } else {
    setSelectedRowIds([]);
  }
},
  onSelectAll: (selected: boolean, selectedRows: any[]) => {
    if (selected) {
      const allKeys = updatedData.map((item: any) => item.id);
      setSelectedRowIds(allKeys);
      setSelectedRows(updatedData);
    } else {
      setSelectedRowIds([]);
      setSelectedRows([]);
    }
  },
};
 
  const handleClearAll = () => {
  //  setSelectedSpeciality("");
  
    setSearchquery("");
   const thunkArgs = {}
    dispatch(fetchNonMembersList(thunkArgs));
    dispatch(fetchMembersList(thunkArgs));
    dispatch(fetchDeletedMembersList(thunkArgs));
  };

  const resetTableSelection = () => {
    setSelectedRows([]);
  };

  const TABS = [
    { label: 'Dynamic Networks', key: 'networks', status: 'networks' },
    { label: 'Deactivated Networks', key: 'deactivated', status: 'deactivated' },
    // { label: 'Deleted Members', key: 'deleted', status: 'deleted' },
  ];


const handleTabChange = (key: string) => {
  setActiveTab(key);
  setPageNumber(1);

  const thunkArgs = { searchquery: searchquery || "", pageNumber: 1 };

  if (key === "networks") {
    dispatch(fetchDynamicNetworksList(thunkArgs));
  } else if (key === "deactivated") {
    dispatch(fetchDeactivatedNetworksList(thunkArgs));
  }

  handleClearAll();
};
  const handlePageChange = (page: number) => {
    setPageNumber(page);
  };

 const handleViewDetails = async (user: any) => {
 
  const response = await dispatch(
    fetchViewDynamicNetworksList({
      searchquery: user?.network_name, // ✅ Passing user.id correctly
      pageNumber: 1,         // ✅ Optional, can be dynamic
    })
  );


  if (response?.payload?.isSuccess) {
    setSelectedUser(user);
    setIsUserDetailModalVisible(true);
  }
};

  const handleModalClose = () => {
    setIsUserDetailModalVisible(false);
    setSelectedUser(null);
  };


  const nonMemberColumns = [
    {
      title: 'Network Name',
      dataIndex: 'network_name',
      key: 'network_name',

            render: (_: any, record: any) => (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {/* <Avatar size={32} src={record.profile_pic ?? DEFAULT_PROFILE_IMAGE} alt={record.display_name} /> */}
                <div>
                  <div style={{ fontWeight: 500, fontSize: 13 }}>{record.network_name}</div>
                </div>
              </div>
            ),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
       render: (_: any, record: any) => (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {/* <Avatar size={32} src={record.profile_pic ?? DEFAULT_PROFILE_IMAGE} alt={record.display_name} /> */}
                <div>
                  <div style={{ fontWeight: 500, fontSize: 13 }}>{record.description}</div>
                </div>
              </div>
            ),
    },

 {

      title: 'Payment Amount',
      dataIndex: 'payment_details',
      key: 'payment_details',
     render: (numbers: string[], record: any) => {
    // Subscription price
    const price = record?.subscription?.plan?.price
      ? `${record.subscription.plan.price} ${record.subscription.plan.currency}`
      : 'N/A';

    if (!Array.isArray(numbers) || numbers.length === 0) {
      return price;
    }

        // Style object for license "pill"
        const pillStyle: React.CSSProperties = {

          padding: '4px 8px',
          borderRadius: '6px',
          display: 'inline-block',
          fontSize: '13px',
          fontWeight: 500,
          color: '#ffffffff'
        };

        // Only one license → show styled pill
        if (numbers.length === 1) {
          return <span style={pillStyle}>{numbers[0]}</span>;
        }

        // Multiple license numbers → first license + plus count
        return (
          <>
            <span style={pillStyle}>{numbers[0]}</span>
            <span
              onClick={() => handleShowLicenses(numbers)}
              style={{

                padding: '4px 6px',
                borderRadius: '6px',
                marginLeft: '6px',
                cursor: 'pointer',
                color: '#1890ff',
                fontSize: '13px',
                fontWeight: 500,
                display: 'inline-flex',
                alignItems: 'center'
              }}
            >
              <PlusOutlined style={{ fontSize: '12px', marginRight: '2px' }} />
              {numbers.length - 1} more
            </span>
          </>
        );
      }
    },


    {
      title: 'Payment Plan ',
      dataIndex: 'payment_plan',
      key: 'payment_plan',
      render: (_: any, record: any) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div>
            <div style={{ fontWeight: 500, fontSize: 13 }}>
              {record.subscription.plan.name || 'N/A'}
            </div>
          </div>
        </div>
      ),
    },


    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: UserData) => (
        <Button
          type="primary"
          size="small"
          icon={<EyeOutlined />}
          style={{ fontSize: 12, height: 28 }}
          onClick={() => handleViewDetails(record)}
        >
          View
        </Button>
      ),
    },
  

  ];

const renderTableContent = () => {
  let dataToRender = [];
  let columnsToRender = nonMemberColumns;

  if (activeTab === 'networks') {
    dataToRender = updatedData || [];
  } else if (activeTab === 'deactivated') {
    dataToRender = deactivatedNetworksList || [];
  }

 return (


  
  <Table
   rowKey={(record:any) => record.id || record.network_name}  // ✅ Unique key for each row
    rowSelection={rowSelection}
    columns={columnsToRender}
    dataSource={dataToRender}
    pagination={{
      position: ["bottomRight"],
      pageSize: 15,
      current: pageNumber,
      onChange: (page) => handlePageChange(page),
      showSizeChanger: false,
      showQuickJumper: true,
      showTotal: (total, range) => (
        <div className="pagniation-text">
          {`${range[0]}-${range[1]} of ${total} items`}
        </div>
      ),
    }}
    // rowKey="id" // ✅ Always add rowKey to avoid key issues
    size="small"
    style={{ fontSize: 13 }}
  />
);
};

  const tabItems = TABS.map(tab => ({
    label: tab.label,
    key: tab.key,
    children: isLoading ? (
      <div style={{ padding: '20px' }}>
        <Skeleton active paragraph={{ rows: 8 }} />
      </div>
    ) : (
      renderTableContent()
    ),
  }));

  return (
    <div className="request-lists-container">

      <Row className="button-container" gutter={[16, 16]} align="middle" justify="space-between">
        <Col xs={24} sm={24} md={12}>
          <Row gutter={8} align="middle">
            <Col flex="auto">
              <span className="search-bar">
                <Input
                  placeholder="Search"
                  prefix={<LiaSearchSolid className="search-bar-icon" />}
                  onChange={(e) => setSearchquery(e.target.value)}
                />
              </span>
            </Col>
            <Col>
              <SimpleButton 
                text="Search"
                color="primary"
                icon={<SearchOutlined />}
                onClick={handleSearch}
              />
            </Col>
          </Row>
        </Col>
      </Row>


      <Modal
        title="Medical License Number"
        open={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        bodyStyle={{
          backgroundColor: "#1f1f1f", // dark background
          padding: "16px",
          maxHeight: "400px",
          overflowY: "auto"
        }}
        style={{
          top: 20
        }}
      >
        {licenseNumbers.length > 0 ? (
          <List
            dataSource={licenseNumbers}
            renderItem={(item) => (
              <List.Item
                style={{
                  backgroundColor: "#141414",
                  color: "#fff",
                  marginBottom: "8px",
                  borderRadius: "6px",
                  padding: "10px 12px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <span>{item}</span>

              </List.Item>
            )}
          />
        ) : (
          <p style={{ color: "#ccc" }}>No license numbers available.</p>
        )}
      </Modal>
  
      <Tabs
       items={tabItems}
        defaultActiveKey="networks"
        activeKey={activeTab}
        onChange={handleTabChange}
        className="network-tabs"
        tabBarExtraContent={
          activeTab === "networks" ?
            <div className="register-user-btn-wrapper" style={{ display: "flex", gap: "8px" }}>
                      <SimpleButton opacity={selectedRowIds?.length === 0? 0.5:1}  disabled={selectedRowIds?.length === 0}
                      text="Deactivate"
                      color="danger-default"
                      onClick={handleDeactivateUser}
                    />
            </div>
             :   <div className="register-user-btn-wrapper" style={{ display: "flex", gap: "8px" }}>
                      <SimpleButton opacity={selectedRowIds?.length === 0? 0.5:1}  disabled={selectedRowIds?.length === 0}
                      text="Activate"
                      color="danger-default"
                      onClick={handleActivateUser}
                    />
            </div>
        }
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          margin: "10px 0",
        }}
      >

      </div>

    <NetworkDetailsModal
  fromMemberPage={true}
  isVisible={!!isUserDetailModalVisible}
  user={selectedUser}   // Must be a single UserData object
  onClose={handleModalClose}
  onAccept={() => {}}
  onReject={() => {}}
  currentTab={activeTab}
  onEdit={() => {}}
  onDelete={() => {}}
  onVerifyLicense={() => {}}
  onRejectLicense={() => {}}
  onEditLicense={() => {}}
  onSaveLicense={() => {}}
/>

    </div>
  );
}
